import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../lib/api.service';
import { ModalService } from '../../lib/modal.service';
import { LogService } from '../../lib/log.service';
import { User } from '../../models/user';
import { Activity } from '../../models/activity';
import { UserService } from '../../lib/user.service';
import { UtilityService } from 'app/lib/utility.service';
import moment from 'moment';

@Component({
    selector: 'app-user-profile-details',
    templateUrl: './user-profile-details.component.html',
    styleUrls: ['./user-profile-details.component.scss'],
    standalone: false
})
export class UserProfileDetailsComponent implements OnInit {
    user: User;
    id: number;
    isloaded: boolean = false;
    offset: number = 0;
    activity: Activity[] = [];
    paramsSub: any;
    showMoreLink: boolean = true;

    constructor(
        private api: ApiService,
        private modalService: ModalService,
        private log: LogService,
        private userService: UserService,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {}

    ngOnInit() {
        this.paramsSub = this.activatedRoute.params.subscribe(
            params => (this.id = parseInt(params['id'], 10))
        );

        this.getUserDetails(this.id);
        this.getActivity();
    }

    getUserDetails(id: number) {
        this.isloaded = false;
        this.api.get('users/' + id, {}).subscribe(
            (result: any) => {
                this.user = new User(result.data);
                // convert UTC to local time
                const utcDate = moment.utc(this.user.loginOn);
                this.user.loginOn = utcDate
                    .local()
                    .format('YYYY-MM-DD, hh:mm:ss a');
                this.api.post('audit/loguserview/' + this.user.id, {});
                this.isloaded = true;
            },
            (error: any) => {
                this.isloaded = true;
                this.modalService.showAlert('Error', 'Something went wrong!');
                this.log.error('Error fetching user. ' + error.message);
            }
        );
    }

    showMore() {
        this.offset = this.activity.length;
        this.getActivity();
    }

    getActivity() {
        this.api
            .post('users/activity', {
                UserID: this.id,
                Limit: 20,
                Offset: this.offset,
            })
            .subscribe(
                (result: any) => {
                    if (result.data.length > 0) {
                        for (let i = 0; i < result.data.length; i++) {
                            this.activity.push(new Activity(result.data[i]));
                        }
                    } else {
                        this.showMoreLink = false;
                    }
                },
                (error: any) => {
                    this.log.error('Error fetching activity. ' + error.message);
                }
            );
    }

    onEdit() {
        this.router.navigate(['/admin/user', this.id, 'edit']);
    }

    onResendWelcome() {
        this.api
            .post('users/resendwelcome', {
                UserID: this.id,
            })
            .subscribe(
                (result: any) => {
                    this.modalService.showAlert(
                        'Success',
                        'Welcome email has been sent'
                    );
                },
                (error: any) => {
                    this.modalService.showAlert(
                        'Error',
                        'Something went wrong. Please try again.'
                    );
                }
            );
    }

    onResendConfirmation() {
        this.api
            .post('users/resendconfirmation', {
                UserID: this.id,
            })
            .subscribe(
                (result: any) => {
                    this.modalService.showAlert(
                        'Success',
                        'Confirmation email has been sent'
                    );
                },
                (error: any) => {
                    this.modalService.showAlert(
                        'Error',
                        'Something went wrong. Please try again.'
                    );
                }
            );
    }

    onDelete() {
        this.modalService
            .showConfirmation(
                'Delete',
                'Are you sure you want to delete this account?'
            )
            .afterClosed()
            .subscribe(result => {
                if (result) {
                    this.api.delete('users/' + this.id).subscribe(
                        (result: any) => {
                            this.modalService.showAlert(
                                'Success',
                                'User has been deleted'
                            );
                            this.router.navigateByUrl('/admin/user-listing');
                        },
                        (error: any) => {
                            this.modalService.showAlert(
                                'Error',
                                'Something went wrong. Please try again.'
                            );
                        }
                    );
                }
            });
    }

}
